import { Component } from "@angular/core";

@Component({
  selector: "kpr-report-demo",
  templateUrl: "./demo-report.component.html",
  styleUrls: [],
})
export class DemoReportComponent {}
